<template>
    <div class="page">
        <!-- 搜索 -->
        <el-form v-if="isSearch" :model="queryForm" ref="form" label-width="80px" :inline="true" size="small"
                 class="query-form" @submit.native.prevent>
            <el-form-item label="名称">
                <el-input v-model="queryForm.tabbarName"></el-input>
            </el-form-item>
            <el-form-item label="页面链接">
                <el-input v-model="queryForm.pageLink"></el-input>
            </el-form-item>
            <el-form-item label="排序">
                <el-input v-model="queryForm.sort"></el-input>
            </el-form-item>
            <el-form-item label="备注">
                <el-input v-model="queryForm.remarks"></el-input>
            </el-form-item>
            <el-form-item>
                <el-button size="small" type="primary" icon="el-icon-search" @click="getMppAppTabbarList">查询
                </el-button>
                <el-button size="small" icon="el-icon-refresh" @click="resetDialog">重置</el-button>
            </el-form-item>
        </el-form>
        <div class="page-content">
            <div class="page-tool-bar">
                <div class="el-btn-group">
                    <el-button
                        type="primary"
                        size="small"
                        icon="el-icon-plus"
                        @click="addMppAppTabbar"
                    >新建
                    </el-button>
                    <el-button
                        type="warning"
                        plain
                        size="small"
                        icon="el-icon-edit"
                        :disabled="multipleSelection.length != 1"
                        @click="editMppAppTabbar(null)"
                    >修改
                    </el-button>
                    <el-button
                        type="danger"
                        plain
                        size="small"
                        icon="el-icon-delete"
                        :disabled="multipleSelection.length <= 0"
                        @click="deleteMppAppTabbar(null)"
                    >删除
                    </el-button>
                </div>

                <div class="icon-group">
                    <el-upload v-if="this.isImportDate"
                        class="upload-demo"
                        action="#"
                        :http-request="upload"
                        :show-file-list="true">
                        <el-button size="small" type="primary">点击上传</el-button>
                        <div slot="tip" class="el-upload__tip">只允许导入“xls”或“xlsx”格式文件！</div>
                    </el-upload>
                    <span
                        title="搜索"
                        class="icon-box"
                        @click="search"
                    >
                      <Icon color="#606266">
                        <Search />
                      </Icon>
                    </span>
                    <span
                        title="下载模板"
                        class="icon-box"
                        @click="importTemplate"
                    >
                      <Icon color="#606266">
                        <ArrowDown />
                      </Icon>
                    </span>
                    <span
                        class="icon-box"
                        title="导入数据"
                        @click="isImport"
                    >
                      <Icon color="#606266">
                        <ArrowExportUp24Regular />
                      </Icon>
                    </span>
                    <span
                        title="导出数据"
                        class="icon-box"
                        @click="exportMppAppTabbarList"
                    >
                      <Icon color="#606266">
                        <ArrowDownload24Regular />
                      </Icon>
                    </span>
                    <span
                        class="icon-box"
                        @click="refreshMppAppTabbarList"
                    >
                      <Icon color="#606266">
                        <Refresh />
                      </Icon>
                    </span>
                </div>
            </div>
            <!-- 列表数据 -->
            <el-table
                :data="mppAppTabbarList"
                row-key="id"
                border
                height="100%"
                :header-row-style="{height: '10px'}"
                :header-cell-style="{padding: '10px'}"
                :row-style="{height: '9px'}"
                :cell-style="{padding: '9px'}"
                @selection-change="handleSelectionChange"
                size="small"
            >
                <el-table-column
                    align="center"
                    type="selection"
                    width="60"
                ></el-table-column>
                <el-table-column
                    :show-overflow-tooltip="true"
                    align="center"
                    prop="tabbarName"
                    label="名称"
                ></el-table-column>
                <el-table-column
                    :show-overflow-tooltip="true"
                    align="center"
                    prop="isShow"
                    label="是否显示"
                >
                    <template scope="scope">
                        <el-switch
                            :value="scope.row.isShow ? true : false"
                            @change="switchChange(scope.row)"
                            active-color="#13ce66"
                            inactive-color="#ff4949">
                        </el-switch>
                    </template>
                </el-table-column>
                <el-table-column
                    :show-overflow-tooltip="true"
                    align="center"
                    prop="tabbarIcon"
                    label="图标"
                >
                    <template scope="scope">
                       <span :class="scope.row.tabbarIcon"></span>
                    </template>
                </el-table-column>
                <el-table-column
                    :show-overflow-tooltip="true"
                    align="center"
                    prop="pageLink"
                    label="页面链接"
                >
                    <template scope="scope">
                        <span>{{scope.row.pageLink.replace(/&amp;/g, "&")}}</span>
                    </template>
                </el-table-column>
                <el-table-column
                    :show-overflow-tooltip="true"
                    align="center"
                    prop="sort"
                    label="排序"
                ></el-table-column>
                <el-table-column
                    :show-overflow-tooltip="true"
                    align="center"
                    prop="remarks"
                    label="备注"
                ></el-table-column>
<!--                <el-table-column-->
<!--                    :show-overflow-tooltip="true"-->
<!--                    align="center"-->
<!--                    prop="createTime"-->
<!--                    label="创建时间"-->
<!--                ></el-table-column>-->
                <el-table-column
                    fixed="right"
                    align="center"
                    label="操作"
                    width="300"
                >
                    <template scope="scope">
                        <div class="operation">
                            <div @click="checkMppAppTabbar(scope.row.id)">
                                <Icon size="16">
                                    <Eye24Regular />
                                </Icon>
                                <span class="operation-label">查看</span>
                            </div>
                            <div @click="editMppAppTabbar(scope.row.id)">
                                <Icon size="16">
                                    <Edit24Regular />
                                </Icon>
                                <span class="operation-label">修改</span>
                            </div>
                            <div @click="deleteMppAppTabbar(scope.row.id)">
                                <Icon size="16" style="color: red">
                                    <Delete24Regular />
                                </Icon>
                                <span class="operation-label" style="color: red">删除</span>
                            </div>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
            <div class="pagination-box">
                <el-pagination
                    @size-change="sizeChange"
                    @current-change="currentChange"
                    :current-page.sync="currentPage"
                    :page-sizes="[10, 20, 50, 100]"
                    :page-size="pageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="totalNum"
                    background
                    :pager-count="7"
                >
                </el-pagination>
            </div>
            <!-- 新增/查看/修改信息 -->
            <el-dialog
                :title="mppAppTabbarStates[mppAppTabbarState]"
                :visible.sync="showDialog"
                width="60%"
                @close="closeDialog"
            >
                <div>
                    <el-form
                        :model="mppAppTabbar"
                        ref="mppAppTabbarForm"
                        :rules="rules"
                        label-width="120px"
                        :inline="true"
                        size="small"
                    >
                        <el-form-item
                            label="页面名称"
                            prop="tabbarName"
                        >
                            <el-input
                                style="width: 200px"
                                size="small"
                                v-model="mppAppTabbar.tabbarName"
                                :disabled="mppAppTabbarState == 'check'"
                            ></el-input>
                        </el-form-item>
                        <el-form-item
                            label="页面链接"
                            prop="pageLink"
                        >
                            <pathselect
                                style="width: 200px"
                                :value="mppAppTabbar.pageLink"
                                :disabled="mppAppTabbarState == 'check'"
                                @change="changePathSelect"
                            ></pathselect>
                        </el-form-item>
                        <el-form-item
                            label="tabbar排序"
                            prop="sort"
                        >
                            <el-input
                                style="width: 200px"
                                size="small"
                                v-model="mppAppTabbar.sort"
                                :disabled="mppAppTabbarState == 'check'"
                            ></el-input>
                        </el-form-item>
                        <el-form-item
                            label="tabbar备注"
                            prop="remarks"
                        >
                            <el-input
                                style="width: 200px"
                                size="small"
                                v-model="mppAppTabbar.remarks"
                                :disabled="mppAppTabbarState == 'check'"
                            ></el-input>
                        </el-form-item>
                        <el-form-item
                            label="菜单图标"
                            prop="sort"
                        >
                            <e-icon-picker size="small" v-model.lazy="mppAppTabbar.tabbarIcon" clearable/>
                        </el-form-item>
                    </el-form>
                </div>

                <div
                    slot="footer"
                    class="flex justify-end"
                >
                    <el-button @click="closeDialog">关闭</el-button>
                    <el-button
                        type="primary"
                        @click="submitForm"
                        v-if="mppAppTabbarState != 'check'"
                    >确定
                    </el-button>
                </div>
            </el-dialog>
        </div>
    </div>
</template>

<script>
import { ArrowDownload24Regular, ArrowExportUp24Regular } from '@v2icons/fluent';
import { GridDots, Refresh, Printer, ArrowUp, ArrowDown, Search } from '@v2icons/tabler';
import { Edit24Regular, Delete24Regular, Eye24Regular } from '@v2icons/fluent';
import { exprotExcel, importTemplate, importDate, get, post, put, deleteFun, upload } from '@/utils/request.js';
import { UPLOAD_PATH } from '@/utils/constant';
import Pathselect from '@/components/pathselect/pathselect.vue';

export default {
    components: {
        Edit24Regular,
        Delete24Regular,
        Eye24Regular,
        GridDots,
        Refresh,
        Printer,
        ArrowUp,
        ArrowDown,
        ArrowDownload24Regular,
        ArrowExportUp24Regular,
        Search,
        Pathselect
    },
    watch: {
        checkState(val) {
            if (val == 'check') {
                this.resetMppAppTabbarList();
                this.getMppAppTabbarList(this.queryForm);
                this.$emit('resetCheckState');
            } else if (val == 'reset') {
                this.resetMppAppTabbarList();
                this.getMppAppTabbarList();
                this.$emit('resetCheckState');
            }
        }
    },
    data() {
        return {
            queryForm: {
                tabbarName: '', //名称
                pageLink: '', //页面链接
                sort: '', //排序
                remarks: '' //备注
            },
            loading: false,
            showDialog: false,
            isImportDate: false,
            isSearch: false,
            pageSize: 10,
            currentPage: 1,
            totalNum: 0,
            currentUserId: '',
            mppAppTabbarState: 'add',
            mppAppTabbarStates: {
                add: '新建底部菜单',
                check: '查看底部菜单',
                edit: '修改底部菜单'
            },

            multipleSelection: [],
            mppAppTabbarList: [],
            mppAppTabbar: {
                tabbarName: '', //名称
                tabbarIcon: '', // 图标
                pageLink: '', //页面链接
                isShow: '', // 是否显示
                sort: '', //排序
                remarks: '', //备注
            },
            btnLoading: false,

            rules: {
                tabbarName: [{ required: true, message: '名称不能为空', trigger: 'blur' }],
                tabbarIcon: [{ required: true, message: '图标不能为空', trigger: 'blur' }],
                pageLink: [{ required: true, message: '页面链接不能为空', trigger: 'blur' }],
                sort: [{ required: true, message: '排序不能为空', trigger: 'blur' }],
                remarks: [{ required: true, message: '备注不能为空', trigger: 'blur' }]
            }
        };
    },
    created() {
        this.getMppAppTabbarList();
    },
    methods: {
        search() {
            this.isSearch = !this.isSearch;
        },
        resetMppAppTabbarList() {
            this.pageSize = 10;
            this.currentPage = 1;
            this.mppAppTabbarList = [];
        },
        resetDialog() {
            this.mppAppTabbarState = 'add';
            this.showDialog = false;
            this.queryForm = {
                tabbarName: '', //名称
                pageLink: '', //页面链接
                sort: '', //排序
                remarks: '' //备注
            };
            this.getMppAppTabbarList();
        },
        closeDialog() {
            this.showDialog = false;
            this.mppAppTabbar = {
                tabbarName: '', //名称
                tabbarIcon: '', // 图标
                iconPath: '', //图标
                isShow: '', // 是否显示
                sort: '', //排序
                remarks: '', //备注
            };
        },
        submitForm() {
            if (this.mppAppTabbarState == 'add') {
                this.$refs.mppAppTabbarForm.validate((valid) => {
                    if (valid) {
                        console.log('submit');
                        post(`/mpp/apptabbar/add`, { ...this.mppAppTabbar }).then((res) => {
                            if (res.success) {
                                this.$message({
                                    message: res.msg,
                                    type: 'success',
                                    duration: 2000
                                });
                                this.resetMppAppTabbarList();
                                this.resetDialog();
                            } else {
                                this.$message({
                                    message: res.msg,
                                    type: 'error',
                                    duration: 2000
                                });
                            }
                        });
                    }
                });
            } else if (this.mppAppTabbarState == 'edit') {
                this.$refs.mppAppTabbarForm.validate((valid) => {
                    if (valid) {
                        console.log('submit');
                        post(`/mpp/apptabbar/edit`, { ...this.mppAppTabbar }).then((res) => {
                            if (res.success) {
                                this.$message({
                                    message: res.msg,
                                    type: 'success',
                                    duration: 2000
                                });
                                this.resetMppAppTabbarList();
                                this.resetDialog();
                            } else {
                                this.$message({
                                    message: res.msg,
                                    type: 'error',
                                    duration: 2000
                                });
                            }
                        });
                    }
                });
            }
        },
        addMppAppTabbar() {
            this.showDialog = true;
            this.mppAppTabbarState = 'add';
        },
        checkMppAppTabbar(mppAppTabbarId) {
            console.log(mppAppTabbarId);
            this.currentMppAppTabbarId = mppAppTabbarId;

            this.getMppAppTabbarById();
            this.showDialog = true;
            this.mppAppTabbarState = 'check';
        },
        editMppAppTabbar(mppAppTabbarId) {
            console.log('mppAppTabbar', mppAppTabbarId);
            if (mppAppTabbarId) {
                this.currentMppAppTabbarId = mppAppTabbarId;
                this.getMppAppTabbarById();
            } else {
                this.mppAppTabbar = { ...this.mppAppTabbar, ...this.multipleSelection[0] };
            }

            this.showDialog = true;
            this.mppAppTabbarState = 'edit';
        },
        deleteMppAppTabbar(mppAppTabbarId) {
            let ids = '';
            if (mppAppTabbarId) {
                ids = mppAppTabbarId;
            } else {
                ids = this.multipleSelection.map((mppAppTabbar) => mppAppTabbar.id).join(',');
            }
            console.log({ ids });
            this.$confirm('确定删除所选项吗？', '提示', {
                type: 'warning'
            })
                .then(() => {
                    deleteFun(`/mpp/apptabbar/delete`, { ids }).then((res) => {
                        if (res.success) {
                            this.$message({
                                message: res.msg,
                                type: 'success',
                                duration: 2000
                            });
                            this.resetMppAppTabbarList();
                            this.getMppAppTabbarList();
                        } else {
                            this.$message({
                                message: res.msg,
                                type: 'error',
                                duration: 2000
                            });
                        }
                    });
                })
                .catch(() => {
                });
        },
        refreshMppAppTabbarList() {
            this.resetMppAppTabbarList();
            this.getMppAppTabbarList();
        },
        getMppAppTabbarList(query = {}) {
            this.loading = true;
            get(`/mpp/apptabbar/findList`, {
                ...this.queryForm,
                pageNum: this.currentPage,
                pageSize: this.pageSize
            }).then((res) => {
                this.loading = false;
                if (res.success) {
                    this.mppAppTabbarList = res.page.list;
                    this.totalNum = res.page.total;
                } else {
                    this.$message({
                        message: res.msg,
                        type: 'error',
                        duration: 2000
                    });
                }
            });
        },
        getMppAppTabbarById() {
            get(`/mpp/apptabbar/get`, { id: this.currentMppAppTabbarId }).then((res) => {
                if (res.success) {
                    this.mppAppTabbar = { ...this.mppAppTabbar, ...res.mppAppTabbar };
                } else {
                    this.$message({
                        message: res.msg,
                        type: 'error',
                        duration: 2000
                    });
                }
            });
        },
        /**
         * 导出信息
         */
        exportMppAppTabbarList() {
            //this.btnLoading = true;
            exprotExcel(`/mpp/apptabbar/export`, { ...this.queryForm });
        },
        /**
         * 导出模板
         */
        importTemplate() {
            this.btnLoading = true;
            importTemplate(`/mpp/apptabbar/importTemplate`, this.btnLoading);
        },
        /**
         * 导入数据
         */
        isImport() {
            this.isImportDate = !this.isImportDate;
        },
        upload(params) {
            const file = params.file;
            const formData = new FormData();
            formData.append('file', file);
            console.log({ formData });
            importDate(`/mpp/apptabbar/importData`, formData);
            this.refreshMppAppTabbarList();
        },
        handleSelectionChange(value) {
            console.log(value);
            this.multipleSelection = value;
        },
        currentChange(page) {
            this.currentPage = page;
            this.getMppAppTabbarList();
        },
        sizeChange(size) {
            this.pageSize = size;
            this.getMppAppTabbarList();
        },
        changePathSelect(path) {
            this.mppAppTabbar.pageLink = path;
        },

        // isShow开关
        switchChange(e){
            post(`/mpp/apptabbar/edit`, {
                id: e.id,
                isShow: e.isShow ? 0 : 1
            }).then((res) => {
                if (res.success) {
                    this.$message({
                        message: res.msg,
                        type: 'success',
                        duration: 2000
                    });
                    this.resetMppAppTabbarList();
                    this.resetDialog();
                } else {
                    this.$message({
                        message: res.msg,
                        type: 'error',
                        duration: 2000
                    });
                }
            });
        }
    }

};
</script>

<style lang="scss" scoped>
::v-deep .el-dialog__header {
    border-bottom: 1px solid #eee;
}

.operation {
    display: flex;
    align-items: center;
    justify-content: center;
    color: #409eff;
    font-size: 12px;

    & > div {
        display: flex;
        align-items: center;
        padding: 0 5px;
        cursor: pointer;
    }

    .operation-label {
        margin-left: 3px;
    }
}
::v-deep .el-tooltip{
    width: auto !important;
}

.avatar-uploader .el-upload:hover {
    border-color: #409eff;
}
.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 200px;
    height: 200px;
    line-height: 200px;
    text-align: center;
}
.avatar {
    width: 200px;
    height: 200px;
    display: block;
}
::v-deep .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    width: 200px;
    height: 200px;
}

</style>